class Step {
    constructor(step, name, element) {
        this.step = step;
        this.name = name;
        this.element = element;

        if (!this.element)
            return;

        this.nextButton = this.element.find(`[data-register-action="next"]`);
        this.previousButton = this.element.find(`[data-register-action="previous"]`);
        this.finalButton = this.element.find(`[data-register-action="finish"]`);

        // Bind events
        if (this.nextButton) {
            this.nextButton.on('click', (e) => {
                e.preventDefault();
                $(document).trigger('stepper:next');
            });
        }

        if (this.previousButton) {
            this.previousButton.on('click', (e) => {
                e.preventDefault();
                $(document).trigger('stepper:previous');
            });
        }

        console.log(`Step ${step} (${name}) element found:`, this.element.length > 0);
        console.log('Step constructor', this);
    }

    // send analytics to the server
    stepStarted() {
        console.log('stepStarted')
    }

    // send analytics to the server
    stepCompleted() {
        console.log('stepCompleted')
    }

    init() {

    }

    async isComplete() {
        return false;
    }

    goNext(target = null) {
        if (window.register) {
            window.register.goNext(target);
        } else {
            $(document).trigger('stepper:next', target);
        }
    }

    goPrevious() {
        if (window.register) {
            window.register.goPrevious();
        } else {
            $(document).trigger('stepper:previous');
        }
    }

    goToStep(target) {
        if (window.register) {
            window.register.goToStep(target);
        } else {
            $(document).trigger('stepper:goto', target);
        }
    }
}

export default Step;